import { cn } from "@pulsex/utils";
import BaseCard from "./shared/Cards/BaseCard";
import { useLoadMore } from "@pulsex/hooks";
import { Post } from "@pulsex/types";
import pulseConfig from "@/pulsex.config";
import { IBlock } from "@pulsex/types";

interface ICategoriesInfiniteList {
    hideLoadMore?: boolean;
    block: IBlock;
    isMobile?: boolean;
}

export default function CategoriesInfiniteList({
    block,
    hideLoadMore,
    isMobile
}: ICategoriesInfiniteList) {
    const widget = block?.getMainWidget();

    const { data, fetchNextData, hasNextPage, isFetchingNextPage } =
        useLoadMore(pulseConfig, widget?.loadMoreLink || "", widget?.posts);
    if (!widget) return;

    return (
        <section className={cn("container mx-auto my-5")}>
            <div className="grid grid-cols-12 gap-2 lg:gap-4">
                {data?.map((post: Post) => (
                    <div key={post.id} className="col-span-6 lg:col-span-12">
                        <div className="w-full h-px bg-primary mb-2 lg:hidden"></div>
                        <BaseCard
                            post={post}
                            titleClassName="text-xl lg:text-sm lg:font-bold"
                            variant="opened"
                            orientation={isMobile ? "vertical" : "horizontal"}
                            author={isMobile}
                            showDescription
                            summaryClassName="line-clamp-3"
                        />
                    </div>
                ))}
            </div>
            {!hideLoadMore && hasNextPage && (
                <div className="flex justify-center items-center my-20 lg:my-10">
                    <button
                        onClick={fetchNextData as any}
                        className={cn(
                            "px-10 py-2 rounded border border-blue text-blue dark:border-white dark:text-white",
                            isFetchingNextPage && "opacity-50"
                        )}
                        disabled={isFetchingNextPage}
                    >
                        Show More
                    </button>
                </div>
            )}
        </section>
    );
}
